/**
* 合并相同的单元格
* @param {(Array)} list
* @param {(Array)} spanList
*/
export function getSpanArr (list, spanList) {
  let tableData = []
  // 先给所有的数据都加一个v.rowspan = 1
  list.forEach(item => {
    item.rowspan = 1
  })
  // 循环
  for (let spanIndex = 0; spanIndex < spanList.length; spanIndex++) {
    for (let i = 0; i < list.length; i++) {
      for (let j = i + 1; j < list.length; j++) {
        // 此处可根据相同字段进行合并，此处是根据的id
        if (list[i][spanList[spanIndex]] === list[j][spanList[spanIndex]]) {
          list[i].rowspan++
          list[j].rowspan--
        }
      }
      // 这里跳过已经重复的数据
      i = i + list[i].rowspan - 1
    }
  }
  tableData = list
  return tableData
}
/**
* 给video标签截取某个时间的视频帧作为封面
* @param {DOM Element} video
* @param {(number)} time
*/
export function setPoster(video, time = 0) {
  var canvas = document.createElement('canvas')
  canvas.width = video.videoWidth
  canvas.height = video.videoHeight
  video.currentTime = time // 需要截取的视频帧时间
  canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
  var posterUrl = canvas.toDataURL()
  video.setAttribute('poster', posterUrl)
}

/**
 * 获取地址栏传参
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {val} String // 复制到剪切板
 */
export async function copyClipboard(val) {
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard 向剪贴板写文本
    return navigator.clipboard.writeText(val)
  } else {
    // 创建text area
    const textArea = document.createElement('textarea')
    textArea.value = val
    // 使text area不在viewport，同时设置不可见
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise((resolve, reject) => {
      // 执行复制命令并移除文本框
      document.execCommand('copy') ? resolve() : reject(new Error())
      textArea.remove()
    })
  }
}

export function getSubdomain() {
  // 获取当前页面的主机名
  var hostname = window.location.hostname

  // 分割主机名为各个部分
  var parts = hostname.split('.')

  // 如果有多个部分，最左边的部分即为一级域名
  if (parts.length > 2) {
    return parts[0]
  } else if (parts.length === 2) {
    // 如果只有两个部分，情况可能特殊，考虑本地开发或最低级域名
    return parts[0]
  } else {
    // 如果主机名没有点，例如是'localhost'
    return hostname
  }
}

export function getSecondLevelDomain() {
  var hostname = window.location.hostname

  // 分割主机名为各个部分
  var parts = hostname.split('.')

  // 处理不同情况：如含有二级顶级域名的地区
  // 例如：example.co.uk 应该返回 example 而不是 co
  if (parts.length >= 3) {
    // var lastPart = parts[parts.length - 1]
    var secondToLastPart = parts[parts.length - 2]

    // 常见的二级域名条件
    var commonSecondLevelDomains = ['co', 'com', 'net', 'org']

    // 如果是包含二级域名的地区，需要去掉前两部分才能获取二级域名
    if (commonSecondLevelDomains.includes(secondToLastPart)) {
      return parts.slice(-3, -2)[0] // 最后的三个部分中的倒数第二个
    } else {
      return secondToLastPart
    }
  } else if (parts.length === 2) {
    return parts[0] // 对于没有子域的直接取第一个
  } else {
    return hostname // 处理 localhost 或其他特殊情况
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js